<template lang="pug">
md-table-card.card
  md-tabs.md-transparent(md-fixed)
    md-tab#tab1(md-label='my videos')
      associated-dialog(ref="playlistsDialog")
      form#search(novalidate, @submit.stop.prevent='search')
        .filters
          md-layout.search(md-align='end')
            md-layout.searchContainer(md-flex='33', md-align='end')
              md-layout
                md-input-container
                  label Search
                  md-input(v-model.lazy='searchText',  v-on:keypress.enter="search()" )
              md-layout(md-flex='15', v-if='searchText != ""')
                md-button.md-icon-button.btn(@click='cleanSearchText')
                  md-icon.icon(md-iconset="fa fa-trash-alt")
              md-layout(md-flex='10')
                md-button.md-icon-button.btn(type='submit', :disabled='loading')
                  md-icon.icon(md-iconset="fa fa-search")

          stitch-loader(v-if='loading', :loading='loading', :size='45')
          div(v-else)
            div.titleLine.styleRow
              p.rowElements Image
              p.rowElements.sortable(@click = "onSort('name')") Name {{sort.name === 'name' ? sort.type === 'desc' ? '&darr;' : '&uarr;' : ''}}
              p.rowElements Encoding Status
              p.rowElements Publish Status
              p.rowElements.sortable(@click = "onSort('lastUpdated')") Updated {{sort.name === 'lastUpdated' ? sort.type === 'desc' ? '&darr;' : '&uarr;' : ''}}
              p.rowElements(v-if="!selectedItems.length > 0")
              button.rowElements.btnBulk(v-else, @click="deleteMultipleItems") Delete selected

            div.rowVideos.styleRow(v-for='mediaItem in mediaItems', :key='mediaItem._id', :class='{selected: selectedItems.includes(mediaItem._id)}')

              input.checkBox(type='checkbox', @click='selectMediaItem(mediaItem._id)', :checked='selectedItems.includes(mediaItem._id)')
              div.imgContainer.media-item-img(v-if="mediaItem.encodingStatus === 'completed'")
                img.media-item-img(:src='getVideoPoster(mediaItem)', :alt='mediaItem.name', :width='230', :height='150')
              div.imgContainer.media-item-img.divText(v-else)
                p.status {{mediaItem.encodingStatus}}
                sub.infoText Please refresh to update status

              div.rowElements.itemClick()
                span.nameText(:title="mediaItem.name") {{ mediaItem.name }}
              div.rowElements.itemClick() {{ mediaItem.encodingStatus }}
              div.rowElements.itemClick(v-if="mediaItem.status === 'public'") live
              div.rowElements.itemClick(v-else, @click='selectMediaItem(mediaItem._id)') {{ mediaItem.status }}
              div.rowElements.itemClick() {{ mediaItem.lastUpdated | moment('from') }}
              div.rowElements.iconsContainer(v-if="!selectedItems.length > 0")
                md-button#info-mediaitem.md-icon-button.md-raised.btn(@click='viewAssociatedPlaylists(mediaItem._id, mediaItem.serie, mediaItem.episodeNumber, mediaItem.seasonNumber )')
                    md-icon.icon(md-iconset="fa fa-list")
                md-button#edit-mediaitem.md-icon-button.md-raised.btn(@click='isEncodingInProgress(mediaItem.encodingStatus) ? itemNotEditable() : editMediaItem(mediaItem._id)')
                  md-icon.icon(md-iconset="fa fa-pencil-alt")
                copy-video-url-menu(
                  :media-item='mediaItem',
                  :is-loading='loadingDistributionFor[mediaItem._id]',
                  :distributions='fetchedDistributions[mediaItem._id]',
                  @fetch='fetchDistributionsFor(mediaItem)'
                )
                md-button#delete-mediaitem.md-icon-button.md-raised.btn(@click='deleteMediaItem(mediaItem.name ,mediaItem._id, mediaItem.status, mediaItem.includeInMarketplace)', v-if='isAdmin() || isAccountAdmin()')
                  md-icon.icon(md-iconset="fa fa-trash-alt")
              div.rowElements.iconsContainer(v-else)
                md-button.md-icon-button.md-raised.btn(@click='viewAssociatedPlaylists(mediaItem._id, mediaItem.serie, mediaItem.episodeNumber, mediaItem.seasonNumber )')
                  md-icon.icon(md-iconset="fa fa-list")
                md-button#btnBulkDiv.md-icon-button.md-raised.btn(@click="deleteMultipleItems", :disabled="selectedItems.includes(mediaItem._id) ? false : true")
                  md-icon.icon(md-iconset="fa fa-trash-alt")
          md-table-pagination.md-pagination(
            v-show='hasMediaItemsToDisplay',
            :md-size='currentPagination.size',
            :md-total='totalMediaItems',
            :md-page='currentPagination.page',
            md-label='Videos',
            md-separator='of',
            :md-page-options='[10, 25, 50, 100]',
            @pagination='onPageChanged'
          )
          div#no-results(v-if='hasNoResults')
              md-icon.md-accent(md-iconset="fa fa-exclamation-circle",)
              | No items to show
    md-tab#tab2(md-label='licensed videos')
      rental-price-dialog(ref="rentalPriceDialog", @price-updated="searchLicenses", :playlists-map="playlistsMap")
      form#search-licenses(novalidate, @submit.stop.prevent='searchLicenses')
        .filters
          md-layout.search(md-align='end')
            md-layout.searchContainer(md-flex='33', md-align='end')
              md-layout
                md-input-container
                  label Search
                  md-input(v-model.lazy='searchTextLicenses',  v-on:keypress.enter="searchLicenses()" )
              md-layout(md-flex='15', v-if='searchTextLicenses != ""')
                md-button.md-icon-button.btn(@click='cleanSearchTextLicenses')
                  md-icon.icon(md-iconset="fa fa-trash-alt")
              md-layout(md-flex='10')
                md-button.md-icon-button.btn(type='submit', :disabled='loading')
                  md-icon.icon(md-iconset="fa fa-search")

          stitch-loader(v-if='loading', :loading='loading', :size='45')
          div(v-else)
            div.titleLine.styleRow
              p.rowElements Image
              p.rowElements Name
              p.rowElements Price
              p.rowElements Tags
              p.rowElements Playlists
              p.rowElements(v-if='!selectedLicensedItems.length || !(isAdmin() || isAccountAdmin())')
              button.rowElements.btnBulk(type='button', v-else, @click='deleteLicensedMediaItems()') Delete selected

            div.rowVideos.styleRow(v-for='mediaItem in mediaItemsLicenses', :key='mediaItem._id', :class='{selected: selectedLicensedItems.includes(mediaItem._id)}')

              input.checkBox(type='checkbox', @click='selectLicensedMediaItem(mediaItem._id)', :checked='selectedLicensedItems.includes(mediaItem._id)')

              div.imgContainer.media-item-img()
                img.media-item-img(:src='getVideoPoster(mediaItem)', :alt='mediaItem.name', :width='230', :height='150')

              div.rowElements.itemClick() {{ mediaItem.name }}
              div.rowElements $ {{ getMediaItemPrice(mediaItem) }}
              div.rowElements
                span.tag(v-for="tag in mediaItem.tags") {{ tag }}
              div.rowElements.itemClick() {{ getPlaylistNames(mediaItem) }}
              div.rowElements.iconsContainer
                md-button.md-icon-button.md-raised.btn(@click='viewAssociatedPlaylists(mediaItem._id, mediaItem.serie, mediaItem.episodeNumber, mediaItem.seasonNumber )')
                  md-icon.icon(md-iconset="fa fa-list")
                md-button.md-icon-button.md-raised.btn(@click='openRentalDialog(mediaItem)')
                  md-icon.icon(md-iconset="fa fa-pencil-alt")
                copy-video-url-menu(
                  :media-item='mediaItem',
                  :is-loading='loadingDistributionFor[mediaItem._id]',
                  :distributions='fetchedDistributions[mediaItem._id]',
                  @fetch='fetchDistributionsFor(mediaItem)'
                )
                md-button.md-icon-button.md-raised.btn(@click='deleteLicensedMediaItem(mediaItem.name, mediaItem._id)', v-if='isAdmin() || isAccountAdmin()')
                  md-icon.icon(md-iconset="fa fa-trash-alt")
          md-table-pagination.md-pagination(
            v-show='hasMediaItemsLicensesToDisplay',
            :md-size='currentPaginationLicenses.size',
            :md-total='totalMediaItemsLicenses',
            :md-page='currentPaginationLicenses.page',
            md-label='Videos',
            md-separator='of',
            :md-page-options='[10, 25, 50, 100]',
            @pagination='onPageChangedLicenses'
          )
          div#no-results-licenses(v-if='hasNoResultsLicensed')
              md-icon.md-accent(md-iconset="fa fa-exclamation-circle",)
              | No items to show
</template>

<script>
import mediaItemService from '../../services/mediaItemService';
import playlistService from '../../services/playlistService';
import distributionService from '../../services/distributionService';
import stitchLoader from '../Loader';
import videoMixin from '../../shared-components/videomixins';
import { mapState } from 'vuex';
import AssociatedDialog from './AssociatedDialog.vue';
import RentalPriceDialog from './RentalPriceDialog.vue';
import CopyVideoUrlMenu from './CopyVideoUrlMenu.vue';

const ENCODING_STATUSES_BLOCKED_FROM_EDIT = [
  'new',
  'requested',
  'progressing',
  'uploading video'
];


export default {
  mixins: [videoMixin],
  components: {
    stitchLoader,
    AssociatedDialog,
    RentalPriceDialog,
    CopyVideoUrlMenu
  },
  data() {
    return {
      mediaItems: [],
      mediaItemsLicenses: [],
      totalMediaItems: null,
      totalMediaItemsLicenses: null,
      loading: false,
      currentPagination: {
        page: 1,
        size: 10
      },
      currentPaginationLicenses: {
        page: 1,
        size: 10
      },
      sort: {
        name: 'lastUpdated',
        type: 'desc'
      },
      searchText: '',
      searchTextLicenses: '',
      playlists: {},
      playlistsMap: {},
      playlistsLoadPromise: null,
      selectedItems:[],
      selectedLicensedItems: [],
      deleteMany: false,
      fetchedDistributions: {},
      loadingDistributionFor: {}
    };
  },
  computed: {
    ...mapState({
      siteuser: state => state.user.siteuser
    }),
    searchParams() {
      const params = {
        offset: this.searchText || this.currentPagination.page == 1
          ? 0
          : this.currentPagination.size * (this.currentPagination.page - 1),
        limit: this.$session.get("limitPagination") || this.currentPagination.size,
        sortBy: this.sort.name,
        sortOrder: this.sort.type
      };
      if (params.hasOwnProperty('name')) {
          delete params['name'];
        }

      if (this.searchText) {
        Object.assign(params, { name: this.searchText });
      }
      // This check is to prevent the offset isn't larger than the total items.
      if (this.totalMediaItems != null && params.offset >= this.totalMediaItems) {
        params.offset = 0;
      }

      return params
    },
    searchParamsLicenses() {
      const params = {
        page: this.currentPaginationLicenses.page,
        pageSize: this.$session.get("limitPaginationLicenses") || this.currentPaginationLicenses.size
      };

      if (this.searchTextLicenses) {
        Object.assign(params, { name: this.searchTextLicenses });
      }

      return params;
    },
    hasMediaItemsToDisplay() {
      return !this.loading && this.mediaItems.length > 0;
    },
    hasMediaItemsLicensesToDisplay() {
      return !this.loading && this.mediaItemsLicenses.length > 0;
    },
    hasNoResults() {
      return !this.loading && this.mediaItems.length === 0;
    },
    hasNoResultsLicensed() {
      return !this.loading && this.mediaItemsLicenses.length === 0;
    }
  },
  methods: {
    isEncodingInProgress(encodingStatus) {
      return ENCODING_STATUSES_BLOCKED_FROM_EDIT.includes(encodingStatus);
    },
    showAlertToast(text, icon) {
      this.$swal({
        text: text,
        position: 'bottom-left',
        icon: icon,
        toast: true,
        timer: 3000,
        timerProgressBar: true,
        showConfirmButton: false,
      }
      )
    },
    async fetchDistributionsFor(mediaItem) {
      const id = mediaItem._id;
      if (this.fetchedDistributions[id] !== undefined || this.loadingDistributionFor[id]) return;

      this.$set(this.loadingDistributionFor, id, true);
      try {
        const response = await distributionService.getList({ offset: 0, limit: 1000 });
        const raw = (response.data && response.data.distributions) || [];

        const eligible = Array.isArray(raw) ? 
          raw.filter((d) => Array.isArray(d.items) && d.items.includes(mediaItem._id))
        : 
          [];
        this.$set(this.fetchedDistributions, id, eligible);
      } catch (error) {
        console.error('Error fetching distributions:', error);
        this.$set(this.fetchedDistributions, id, []);
      } finally {
        this.$set(this.loadingDistributionFor, id, false);
      }
    },

    openRentalDialog(mediaItem) {
      this.$refs.rentalPriceDialog.openRentalPriceDialog(mediaItem);
    },

    formatPrice(amount) {
      return (amount / 100).toFixed(2)
    },

    getMediaItemPrice(mediaItem) {
      return mediaItem && mediaItem.prices && mediaItem.prices[0] && mediaItem.prices[0].price
        ? this.formatPrice(mediaItem.prices[0].price.amount)
        : 0;
    },

    getDistributionPlaylistIds(mediaItem) {
      const distributions = (mediaItem && (mediaItem.distributions || mediaItem.distribution)) || [];
      if (!Array.isArray(distributions) || distributions.length === 0) {
        return [];
      }

      const ids = [];
      distributions.forEach((distribution) => {
        const playlistRef = distribution && distribution.source && distribution.source.playlist;
        if (!playlistRef) {
          return;
        }

        if (Array.isArray(playlistRef)) {
          playlistRef.forEach((entry) => {
            if (typeof entry === 'string') {
              ids.push(entry);
            } else if (entry && entry._id) {
              ids.push(entry._id);
            }
          });
          return;
        }

        if (typeof playlistRef === 'string') {
          ids.push(playlistRef);
          return;
        }

        if (playlistRef && playlistRef._id) {
          ids.push(playlistRef._id);
        }
      });

      return Array.from(new Set(ids));
    },

    getPlaylistNames(mediaItem) {
      const playlistIds = this.getDistributionPlaylistIds(mediaItem);
      if (playlistIds.length === 0) {
        return 'N/A';
      }

      const playlistNames = playlistIds.map((playlistId) => this.playlistsMap[playlistId]).filter(Boolean);
      return playlistNames.length > 0 ? playlistNames.join(', ') : 'N/A';
    },

    async loadPlaylists() {
      if (Object.keys(this.playlistsMap).length > 0) {
        return;
      }

      if (this.playlistsLoadPromise) {
        return this.playlistsLoadPromise;
      }

      this.playlistsLoadPromise = (async () => {
        try {
          const response = await playlistService.getList({ offset: 0, limit: 10000 });

          if (response.data && response.data.playlists && Array.isArray(response.data.playlists)) {
            response.data.playlists.forEach((playlist) => {
              if (playlist._id && playlist.name) {
                this.$set(this.playlistsMap, playlist._id, playlist.name);
              }
            });
          } else if (response.data && Array.isArray(response.data)) {
            response.data.forEach((playlist) => {
              if (playlist._id && playlist.name) {
                this.$set(this.playlistsMap, playlist._id, playlist.name);
              }
            });
          }
        } catch (error) {
          console.error('Error loading playlists:', error);
        } finally {
          this.playlistsLoadPromise = null;
        }
      })();

      return this.playlistsLoadPromise;
    },

    selectMediaItem(mediaItem){
      if(!this.selectedItems.includes(mediaItem)){
        this.selectedItems.push(mediaItem)
      }
      else{
        this.selectedItems.splice(this.selectedItems.indexOf(mediaItem), 1)
      }
    },
    selectLicensedMediaItem(mediaItemId) {
      if (!this.selectedLicensedItems.includes(mediaItemId)) {
        this.selectedLicensedItems.push(mediaItemId);
      } else {
        this.selectedLicensedItems.splice(this.selectedLicensedItems.indexOf(mediaItemId), 1);
      }
    },
    escapeHtml(value) {
      return String(value || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    },
    getLicensedMediaItemsByIds(mediaItemIds) {
      const selectedSet = new Set(mediaItemIds || this.selectedLicensedItems);
      return this.mediaItemsLicenses.filter((item) => selectedSet.has(item._id));
    },
    buildLicensedDeleteSummaryHtml(mediaItemsToDelete) {
      const listItems = mediaItemsToDelete.map((mediaItem) => {
        const mediaItemName = this.escapeHtml(mediaItem.name);
        const playlistNames = this.escapeHtml(this.getPlaylistNames(mediaItem));
        return `<li><strong>${mediaItemName}</strong> &rarr; ${playlistNames}</li>`;
      }).join('');
      return `<p>The following video to playlist associations will be removed:</p><ul style="text-align:left; margin:0; padding-left:20px;">${listItems}</ul>`;
    },

    deleteMultipleItems(){
      this.$swal.fire({
        html: `Are you sure you want to delete these ${this.selectedItems.length} videos? <br> <strong>This cannot be undone</strong>`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete',
        cancelButtonText: 'No',
      }).then((res) => {
        if (res.isConfirmed) {
          this.loading = true;
          mediaItemService.bulkDelete(this.selectedItems).then(() => {
            this.showAlertToast('Videos deleted successfully', 'success');
            this.loadingComponent = false;
            this.deleteMany = !this.deleteMany
          })
          .catch(() => {
            this.deleteMany = !this.deleteMany
            this.showAlertToast('Video could not be deleted. Please, try again later', 'error');
          })
        }
      })
    },

    isAdmin() {
      // Check user has 'authorization' and Check user has 'roles'
      if (this.siteuser.authorization && this.siteuser.authorization.roles) {
        return this.siteuser.authorization.roles.includes('Admin');
      }

      return false;
    },

    isAccountAdmin() {

      // Check user has 'authorization' and Check user has 'roles'
      if (this.siteuser.authorization && this.siteuser.authorization.roles) {
        return this.siteuser.authorization.roles.includes('AccountAdmin');
      }

      return false;
    },

    onPageChanged(paginationParams) {
      this.currentPagination = paginationParams;
      this.$session.set("iWasInPage", paginationParams.page);
      this.$session.set("limitPagination", paginationParams.size);
      this.search();
    },
    onSort(sortParams) {
      this.sort.name = sortParams;
      this.sort.type = this.sort.type === 'desc' ? 'asc' : 'desc';
      this.search();
    },

    async search() {
      this.loading = true;
      try {
        const response = await mediaItemService.getList(this.searchParams);
        this.mediaItems = response.data.mediaItems;
        this.totalMediaItems = response.data.total;
      } catch (error) {
        console.error('Error while retrieving the list of media items', error);
      } finally {
        this.loading = false;
      }
    },
    async searchLicenses() {
      this.loading = true;
      try {
        const mediaItemLicensed = await mediaItemService.getLicensesVideos(this.searchParamsLicenses);
        this.mediaItemsLicenses = mediaItemLicensed.data.mediaItems;
        this.totalMediaItemsLicenses = (mediaItemLicensed.data.pagination && mediaItemLicensed.data.pagination.totalCount) || 0;
      } catch (error) {
        console.error('Error while retrieving the list of licensed media items', error);
      } finally {
        this.loading = false;
      }
    },
    editMediaItem(mediaItemId) {
      this.$router.push({
        name: 'EditVideo',
        params: {
          id: mediaItemId
        }
      });
    },
    itemNotEditable() {
      this.$swal.fire({
        position: 'top',
        icon: 'warning',
        text: 'Video properties cannot be edited while encoding is in progress. Please refresh the page to see the updated status',
        showConfirmButton: false,
        timerProgressBar: true,
        timer: 3000
      })
    },
    deleteMediaItem(mediaItemName, mediaItemId, status, includeInMarketplace) {
      this.$swal.fire({
        title: 'Delete video?',
        html: `<p><strong>Name</strong>: ${mediaItemName}</p> <p><strong>Status</strong>: ${status}</p> <p><strong>Include in marketplace</strong>: ${includeInMarketplace ? 'Yes' : 'No'}</p>`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete',
        cancelButtonText: 'No',
      }).then((res) => {
        if (res.isConfirmed) {
          this.loading = true;
          mediaItemService.delete(mediaItemId).then(() => {
            this.search();
          })
            .catch(() => {
              this.showAlertToast('Video could not be deleted. Please, try again later', 'error');
            })
            .then(() => {
              this.loadingComponent = false;
            })
          this.showAlertToast('Video deleted successfully', 'success');
        }
      })
    },
    deleteLicensedMediaItem(mediaItemName, mediaItemId) {

      this.deleteLicensedMediaItems([mediaItemId], mediaItemName);
    },
    deleteLicensedMediaItems(mediaItemIds = this.selectedLicensedItems, mediaItemName = '') {
      const idsToDelete = Array.isArray(mediaItemIds) ? mediaItemIds : this.selectedLicensedItems;
      if (!idsToDelete.length) {
        return;
      }

      const mediaItemsToDelete = this.getLicensedMediaItemsByIds(idsToDelete);
      const defaultDeleteName = mediaItemName ? this.escapeHtml(mediaItemName) : 'selected videos';
      const deleteSummaryHtml = mediaItemsToDelete.length
        ? this.buildLicensedDeleteSummaryHtml(mediaItemsToDelete)
        : `<p><strong>${defaultDeleteName}</strong></p><p>This action removes the account playlist association for the selected licensed videos.</p>`;

      this.$swal.fire({
        title: 'Remove licensed videos?',
        html: deleteSummaryHtml,
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Yes, remove',
        cancelButtonText: 'No',
      }).then(async (res) => {
        if (res.isConfirmed) {
          this.loading = true;
          try {
            await mediaItemService.deletePlaylistsAccountBulk(idsToDelete);
            this.showAlertToast('Licensed videos removed successfully', 'success');
            this.selectedLicensedItems = [];
            await this.searchLicenses();
          } catch (error) {
            this.showAlertToast('Licensed videos could not be removed. Please, try again later', 'error');
          } finally {
            this.loading = false;
          }
        }
      })
    },
    viewAssociatedPlaylists(mediaItemId, serieId, episodeNumber, seasonNumber) {
      this.$refs.playlistsDialog.openDialog(mediaItemId, serieId, episodeNumber, seasonNumber);
    },
    cleanSearchText() {
      this.searchText = '';
      this.search()
    },
    cleanSearchTextLicenses() {
      this.searchTextLicenses = '';
      this.searchLicenses();
    },
    onPageChangedLicenses(paginationParams) {
      this.currentPaginationLicenses = paginationParams;
      this.$session.set("iWasInPageLicenses", paginationParams.page);
      this.$session.set("limitPaginationLicenses", paginationParams.size);
      this.selectedLicensedItems = [];
      this.searchLicenses();
    }
  },
  async mounted() {
    this.$session.set("limitPaginationDomains", this.currentPagination.size);
    this.$session.set("limitPaginationDistributions", this.currentPagination.size);

    if (this.$session.get("iWasInPage") === undefined) {
      this.$session.set("iWasInPage", 1);
    }
    this.currentPagination.page = this.$session.get('iWasInPage');
    if (this.$session.get("limitPagination") === undefined) {
      this.currentPagination.size = this.$session.get("limitPagination");
    }

    if (this.$session.get("iWasInPageLicenses") === undefined) {
      this.$session.set("iWasInPageLicenses", 1);
    }
    this.currentPaginationLicenses.page = this.$session.get('iWasInPageLicenses');
    if (this.$session.get("limitPaginationLicenses") !== undefined) {
      this.currentPaginationLicenses.size = this.$session.get("limitPaginationLicenses");
    }

    this.$session.set("iWasInPageVideoSources", 1);
    this.$session.set("iWasInPagePlaylist", 1);
    this.$session.set("iWasInPageSeries", 1);
    this.$session.set("iWasInPageUserActivity", 1);
    this.$session.set("iWasInPageDistributions", 1);
    this.$session.set("iWasInPageDomains", 1);
    this.$session.set("iWasInPageLicences", 1);
    this.$session.set("iWasInPageNetworks", 1);
    this.loadPlaylists();
    await this.search();
    await this.searchLicenses();
  },
  watch: {
    currentPagination(newValue, oldValue) {
      if (newValue.size !== oldValue.size) {
        this.currentPagination.page = 1
        this.search()
      }
    },
    currentPaginationLicenses(newValue, oldValue) {
      if (newValue.size !== oldValue.size) {
        this.currentPaginationLicenses.page = 1
        this.searchLicenses()
      }
    },
    deleteMany(){
      this.selectedItems = []
      this.search();
    }
  }
};
</script>

<style lang="scss" scoped>
.card {
  border-radius: 10px;
  box-shadow: 1px 1px 20px 5px rgba(0, 0, 0, 0.2);
  margin-top: 20px !important;
  margin: auto !important;
  padding: 10px;
  width: 80vw;
}

.search {
  margin-right: 10px;

  @media (max-width: 1200px) {
    margin-right: 20px;
  }
}
.searchContainer {
  flex: none;

}

.filters {
  padding: 2px 20px;
}

.md-menu {
  min-width: none !important;
  width: none !important;
}

.md-menu-content {
  max-height: 200px;
}

.imgContainer {
  flex: 1;
}
.media-item-img {
  background-color: rgb(0, 0, 0);
  border-radius: 6px;
  height: 10vw;
  max-height: 200px;
  max-width: 300px;
  object-fit: contain;
  width: 100%;
}

.selected{
  border: 1px solid rgb(23, 165, 205) !important;
  border-radius: 6px;
  background-color: rgba(127, 200, 228, 0.1) !important;
}

.checkBox{
  cursor: pointer;
  margin: 10px;
  height: 18px;
  width: 18px;
}
.divText {
  display: inline-flex;
  flex-direction: column;
  justify-content: center;
}

.status {
  color: rgb(223, 223, 223);
  font-size: 1.1em;
  font-style: italic;
  margin: 0 0 13px 0;
  transition: all .3s ease-in;

  @media (max-width: 1200px) {
    font-size: .9em;
    margin: 0 0 5px 0;
  }
}

.status::first-letter {
  text-transform: uppercase
}
@media (max-width: 850px) {
  .btn{
    height: 26px !important;
    min-height: 26px !important;
    min-width: 26px !important;
    width: 26px !important;
  }
  .icon{
    font-size: 14px;
  }
}
.infoText {
  color: #fff;
  font-size: 1.1em;
  font-style: italic;
  line-height: normal;
  margin: 0;
  padding: 0 3px;
  transition: all .3s ease-in;

  @media (max-width: 1200px) {
    font-size: .9em;
  }

  @media (max-width: 1000px) {
    font-size: .8em;
  }
}

#search {
  margin-bottom: 30px;
}

#search-licenses {
  margin-bottom: 30px;
}

.md-table {

  .md-sortable.md-sorted,
  .md-sortable:hover {
    color: #0198cf;
  }
}

#no-results {
  margin: auto;
  padding: 20px;

  .md-icon {
    margin-right: 5px;
  }
}

#no-results-licenses {
  margin: auto;
  padding: 20px;

  .md-icon {
    margin-right: 5px;
  }
}

.md-card-media {
  .overlay-play {
    position: absolute;
    z-index: 100;
    bottom: 0;
    right: 0;
  }
}

.card-action-spinner {
  padding: 8px;
  margin-right: 16px;
}

.card {
  width: 80vw;
  margin: 4rem auto;
}

.rowVideos {
  border: 1px solid transparent;
  &:hover{
    background-color: rgba(127, 199, 228, 0.112) !important;
    border-radius: 6px;
  }
}

.styleRow {
  align-items: center;
  display: flex;
  margin-bottom: 10px;
  text-align: center;
}

.styleRow p {
  font-weight: 600;
}
.rowElements {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
}


.nameText{
  overflow: hidden;
  padding-left: 5px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.btnMargin{
  width: 40px;
}

.itemClick{
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100px;
  padding: 10px;
}
.titleLine {
  border-bottom: solid;
  border-bottom-width: 1px;
  border-bottom-color: rgba(153, 155, 155, 0.486);
}

.sortable:hover {
  cursor: pointer;
  color: #4ea9dd;
}

.md-pagination {
  padding: 10px;
}

.iconsContainer {
  padding: 4px 0px;
  display: grid;
  grid-template-columns: auto auto;
  align-content: center;
  justify-content: center;
}

@media (min-width: 1200px) {
  .iconsContainer {
    row-gap: 4px
  }
}

@media (min-width: 1750px) {
  .iconsContainer {
    padding: 4px 0px;
    display: flex;
    justify-content: center;
  }
}


.btnBulk{
  margin: 0;
  padding: 8px 2px;
  border: none;
  border-radius: 4px;
  font-weight: 600;
  background-color: #d50d0da2;
  color: #fff;
  transition: all .4s;
  &:hover{
    cursor: pointer;
    background-color: #d50d0d !important;
  }
}

#btnBulkDiv{
  &:hover{
    transform: scale(1.05);
    background-color: #d50d0d !important;
  }
}

.tag{
  padding: 2px 5px;
  margin: 2px;
  border-radius: 6px;
  background-color: #d1dfe3ba;
  font-style: italic;
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/shared-components/mediaItem/MediaItemTable.vue